import { useState, useEffect } from 'react';
import { LanguageOrchestrator } from './LanguageOrchestrator';

/**
 * @hook useLanguage
 * @description Reactive shell for the Language Orchestrator.
 */
export const useLanguage = (namespace) => {
  // 1. Initialize with Shadow Data immediately (Zero White Screen)
  const [content, setContent] = useState(() => 
    LanguageOrchestrator.getInitialState(namespace)
  );

  useEffect(() => {
    const refs = { isMounted: true };

    // 2. Trigger the sync (Orchestrator handles the 404)
    LanguageOrchestrator.syncContent(namespace, setContent, content, refs);

    return () => { refs.isMounted = false; };
  }, [namespace]);

  return content;
};